import HourActivity from "./hourActivity";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import GobActivity from "./gobActivity";
import * as _ from "lodash";
import { apsCommon } from "../../shared/dto/aps.common";

export default class JobRunActivity {
  excludedDefectTypeIds: string[];
  wareClassId: string;
  isJobRun: boolean;
  hours: HourActivity[];
  id: string;
  jobId: string;
  jobName: string;
  jobMold: string;
  jobFinish: string;
  shortName: string;
  shopId: string;
  lehrTime: number;
  startDate: Date;
  endDate: Date;
  numberOfSections: number;
  machineDisabledSections: apsCommon.MachineDisabledSections[];
  numberOfGobs: number;
  machinesHaveActivity: {[id: string]: boolean};
  machinesHaveToolChange: {[id: string]: string[]};

  constructor(data: apsViewModels.JobRunActivity) {
    _.assign(this, data);
    this.isJobRun = true;
    this.hours = [];
    this.machinesHaveActivity = {};
    this.machinesHaveToolChange = {};
    if (this.jobMold && this.jobFinish) {
      this.shortName = this.jobMold + ' ' + this.jobFinish;
    } else {
      this.shortName = 'Maintenance';
    }
  }

  hasActivity(gob: GobActivity): boolean {
    return this.machinesHaveActivity[gob.section.machine.id];
  }

  hasToolChange(gob: GobActivity): boolean {
    return this.machinesHaveToolChange[gob.section.machine.id]
      && this.machinesHaveToolChange[gob.section.machine.id].length > 0;
  }

  updateHasActivity(gob: GobActivity, value: boolean): void {
    this.machinesHaveActivity[gob.section.machine.id] = value;
  }

  addToolChange(gob: GobActivity, toolChange: apsViewModels.ToolActivity): void {
    this.updateHasActivity(gob, true);
    let machineId = gob.section.machine.id;
    let id = toolChange.toolChangeId;
    if (this.machinesHaveToolChange[machineId]) {
      if (!this.machinesHaveToolChange[machineId].some(x => x === id)) {
        this.machinesHaveToolChange[machineId].push(id)
      }
    }
    else {
      this.machinesHaveToolChange[machineId] = [id];
    }
  }

  removeToolChange(gob: GobActivity, toolChangeId: string) {
    let machineId = gob.section.machine.id;
    if (!this.machinesHaveToolChange[machineId])
        return;
    this.machinesHaveToolChange[machineId] = this.machinesHaveToolChange[machineId].filter(x => x !== toolChangeId);
  }

  withinJob(time: Date): boolean {
    if (time.getTime() < this.startDate.getTime()) {
      return false;
    }

    if (this.endDate) {
      return time.getTime() < this.endDate.getTime();
    }
    return true;
  }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/models/activity/jobRunActivity.ts